export function formatTimeToMins(timeInSeconds) {
  var seconds = timeInSeconds % 60;
  var minutes = (timeInSeconds - seconds) / 60;

  return (
    String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0")
  );
}
